import script from "./CustomerSingle.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerSingle.vue?vue&type=script&setup=true&lang=js"

import "./CustomerSingle.vue?vue&type=style&index=0&id=43332ee0&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43332ee0"]])

export default __exports__